import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { IApproverConference, IConferenceRequest } from './interface';
import { inject, Injectable } from '@angular/core';
import {
    CreateConferenceForm,
    GetAllRequests,
    GetApproverRequests,
    GetByUser,
    GetSingleConferenceRequest
} from './action';
import { catchError, tap } from 'rxjs';
import { ConfereceService } from './conference.service';

export class IProps {
    conferenceRequest!: IConferenceRequest[];

    singleConferenceRequest!: IConferenceRequest | null;
    approverRes!: IApproverConference[];
    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'conferenceForm',
    defaults: {
        conferenceRequest: [],
        approverRes: [],
        singleConferenceRequest: null,
        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class ConferenceRequestsStore {
    requestsService: ConfereceService = inject(ConfereceService);
    private store: Store = inject(Store);

    @Selector()
    static getConferenceRequests(state: IProps) {
        return state.conferenceRequest;
    }
    @Selector()
    static getApproversConferenceRequests(state: IProps) {
        return state.approverRes;
    }
    @Selector()
    static singleConferenceRequest(state: IProps) {
        return state.singleConferenceRequest;
    }

    @Selector()
    static getUserRequests(state: IProps) {
        return state.conferenceRequest;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }

    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getRequests(action.queryParams as any).pipe(
            tap((res) => {
                ctx.patchState({
                    conferenceRequest: res,
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(CreateConferenceForm)
    createConference(ctx: StateContext<IProps>, action: CreateConferenceForm) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createConferenceForm(action.input).pipe(
            tap((res: any) => {
                ctx.patchState({
                    conferenceRequest: [...state.conferenceRequest, res.requestForm],

                    singleConferenceRequest: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleConferenceRequest)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleConferenceRequest) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingle(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    singleConferenceRequest: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetByUser)
    getByUser(ctx: StateContext<IProps>, action: GetByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getByUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    conferenceRequest: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    @Action(GetApproverRequests)
    getApproverRequest(ctx: StateContext<IProps>, action: GetApproverRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    approverRes: res,
                    // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
}
